import Vue from 'vue';
import VueIziToast from 'vue-izitoast';

import 'izitoast/dist/css/iziToast.min.css';
const options = {
  position: 'bottomRight',
  timeout: 2500
};

Vue.use(VueIziToast, options);
